/* 授课 */
export default [{
  path: '/give',
  name: 'give',
  redirect: '/give/home',
  component: () => import('@/views/give-course/layout'),
  children: [
    {
      // 首页
      path: '/give/home',
      name: 'giveHome',
      component: () => import('@/views/give-course/index'),
    },
    {
      // 目录资源播放
      path: '/give/show',
      name: 'giveShow',
      component: () => import('@/views/give-course/show/index'),
    },
    {
      // 签到
      path: '/give/sigin',
      name: 'giveSigin',
      component: () => import('@/views/give-course/sigin/sigin'),
    },
    {
      // 签到历史记录
      path: '/give/sigin/history',
      name: 'giveSiginHistory',
      component: () => import('@/views/give-course/sigin/History'),
    },
    {
      // 预习任务
      path: '/give/task',
      name: 'givetask',
      component: () => import('@/views/give-course/yxTask/index'),
    },
    {
      // 讨论
      path: '/give/discuss',
      name: 'giveDiscuss',
      component: () => import('@/views/give-course/discuss/index'),
    },
    {
      // 课堂互动 - 举手选人
      path: '/give/interact/select',
      name: 'giveInteractSelect',
      component: () => import('@/views/give-course/interact/select'),
    },
    {
      // 课堂互动 - 首页
      path: '/give/interact',
      name: 'giveInteract',
      component: () => import('@/views/give-course/interact/index'),
    },
    {
      // 作业点评 - 首页
      path: '/give/homeWork',
      name: 'giveHomeWork',
      component: () => import('@/views/give-course/homeWork/index'),
    },
    {
      // 问卷调查 - 首页
      path: '/give/inquiry',
      name: 'giveInquiry',
      component: () => import('@/views/give-course/inquiry/index'),
    },
    {
      // 互评 - 首页
      path: '/give/makeComment',
      name: 'giveMakeCommentSelect',
      component: () => import('@/views/give-course/makeComment/select'),
    },
    {
      // 互评 - 历史
      path: '/give/makeComment',
      name: 'giveMakeComment',
      component: () => import('@/views/give-course/makeComment/index'),
    },
    {
      // 测验 - 首页
      path: '/give/test',
      name: 'giveTest',
      component: () => import('@/views/give-course/test/index'),
    },
    {
      // 画像 - 首页
      path: '/give/portrayal',
      name: 'givePortrayal',
      component: () => import('@/views/give-course/portrayal/index'),
    },
    {
      // 投票 - 首页
      path: '/give/vote',
      name: 'giveVote',
      component: () => import('@/views/give-course/vote/index'),
    },
  ]
}]


// WEBPACK FOOTER //
// ./src/router/give-Course.js